import { BR_ICON, agentOf } from '../../lib/pm';
import { pmT } from '../../lib/i18nPm';

// branch chip: short label, full branch name + assistant in the tooltip (colour per branch via CSS)
export function BrChip({ b, t, active, onClick, testid, off }) {
  const C = onClick ? 'button' : 'span';
  return (
    <C className={`pm-chip br-${b} ${active ? 'active' : ''} ${off ? 'off' : ''}`} data-testid={testid} onClick={onClick} title={`${t[`pf_${b}`] || b} · ${agentOf(b)}`} type={onClick ? 'button' : undefined}>
      {BR_ICON[b]} {pmT().br[b] || b}
    </C>
  );
}
